export default __webpack_public_path__ + "static/media/1167.a9d483c0.png";